import React, { useEffect, useState } from "react";
import ListItems from "./ListItems";
import List from "@mui/material/List";
import { Box, Typography } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PaymentsIcon from "@mui/icons-material/Payments";
import GroupsIcon from "@mui/icons-material/Groups";
import SpeakerGroupIcon from "@mui/icons-material/SpeakerGroup";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import SettingsIcon from '@mui/icons-material/Settings';
import { useSelector } from "react-redux";
import PendingActionsIcon from '@mui/icons-material/PendingActions';

function Sidebar({ open }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const { roles } = useSelector((state) => state.userStatus || { roles: [] });
  const type = roles?.length > 0 ? roles[0]?.role : "ADMIN";

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const renderSidebarContent = () => {
    if (open) {
      return (
        <Box sx={{ 
          display: "flex", 
          flexDirection: "column", 
          height: "100%",
          backgroundColor: "#ffffff",
          padding: "16px 0"
        }}>
          <List 
            component="nav" 
            sx={{ 
              flexGrow: 1,
              paddingTop: 0,
              paddingX: 1,
              "& .MuiListItemButton-root": {
                borderRadius: "8px",
                marginBottom: "2px",
                padding: "12px 16px",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                }
              }
            }}
          >
            <ListItems
              link="/dashboard"
              name="Dashboard"
              icon={<GridViewIcon />}
            />
            <ListItems
              link="/transactions"
              name="Transaction Management"
              icon={<PaymentsIcon />}
            />
            <ListItems
              link="/user_status"
              name="Investor Management"
              icon={<GroupsIcon />}
            />
            <ListItems
              link="/custodians"
              name="Custodian Management"
              icon={<SpeakerGroupIcon />}
            />
            <ListItems
              link="/createkyc"
              name="KYC Management"
              icon={<NoteAddIcon />}
            />
            <ListItems
              link="/activity"
              name="Activity Logs"
              icon={<PendingActionsIcon />}
            />
          </List>
          
          {/* Support Section at Bottom */}
          <Box sx={{ 
            padding: "16px 8px 0 8px",
            borderTop: "1px solid #e0e0e0",
            marginTop: "auto"
          }}>
            <ListItems
              link="/support"
              name="Support"
              icon={<SettingsIcon />}
            />
          </Box>
        </Box>
      );
    } else {
      return (
        <Box sx={{ 
          display: "flex", 
          flexDirection: "column", 
          height: "100%",
          backgroundColor: "#ffffff",
          alignItems: "center",
          padding: "16px 0"
        }}>
          <List 
            component="nav" 
            sx={{ 
              flexGrow: 1,
              paddingTop: 0,
              paddingX: 0,
              "& .MuiListItemButton-root": {
                borderRadius: "8px",
                marginBottom: "2px",
                padding: "12px 8px",
                justifyContent: "center",
                minWidth: "48px",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                }
              }
            }}
          >
            <ListItems
              link="/dashboard"
              icon={<GridViewIcon />}
              mt={true}
            />
            <ListItems
              link="/transactions"
              icon={<PaymentsIcon />}
              mt={true}
            />
            <ListItems
              link="/user_status"
              icon={<GroupsIcon />}
              mt={true}
            />
            <ListItems
              link="/custodians"
              icon={<SpeakerGroupIcon />}
              mt={true}
            />
            <ListItems
              link="/createkyc"
              icon={<NoteAddIcon />}
              mt={true}
            />
            <ListItems
              link="/activity"
              icon={<PendingActionsIcon />}
              mt={true}
            />
          </List>
          
          {/* Support Section at Bottom */}
          <Box sx={{ 
            padding: "16px 0 0 0",
            borderTop: "1px solid #e0e0e0",
            marginTop: "auto",
            width: "100%",
            display: "flex",
            justifyContent: "center"
          }}>
            <ListItems
              link="/support"
              icon={<SettingsIcon />}
              mt={true}
            />
          </Box>
        </Box>
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#ffffff",
      }}
    >
      {renderSidebarContent()}
    </Box>
  );
}

export default Sidebar;

